/**
 * После defaultFilters кэш не должен затирать skillGroups/skillsAny/skillsAll из актуальной вакансии,
 * если в merged они пустые, а в default заданы навыки.
 */
export function mergeCachedFiltersRespectingVacancySkills<T extends Record<string, unknown>>(
  defaultFilters: T,
  cachedFilters: T | null | undefined
): T {
  if (!cachedFilters) return { ...defaultFilters };
  const merged = { ...defaultFilters, ...cachedFilters } as T;
  const skillKeys = ['skillGroups', 'skillsAny', 'skillsAll'] as const;

  for (const key of skillKeys) {
    const defVal = defaultFilters[key as keyof T];
    const hasDefSkills = Array.isArray(defVal) && defVal.length > 0;
    const mergedVal = merged[key as keyof T];
    const mergedEmpty =
      mergedVal == null ||
      (Array.isArray(mergedVal) && mergedVal.length === 0);
    if (hasDefSkills && mergedEmpty) {
      (merged as Record<string, unknown>)[key] = defVal as unknown;
    }
  }
  return merged;
}
